import { z } from "zod";
import { ECustomerAccountSection, schemes } from "@zeal/common";

export const postGenerateCustomerAccountShareableLinkSchema = z.object({
  companyID: schemes.companyID(),
  customerAccountID: schemes.uuid(),
  section: z.nativeEnum(ECustomerAccountSection),
  send_to_admin: z.boolean().optional(),
});

export type TPostGenerateCustomerAccountShareableLinkRequest = z.infer<
  typeof postGenerateCustomerAccountShareableLinkSchema
>;
